import { Metrics } from 'APP/Themes'
import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    paddingBottom: (Metrics.bottomSpace || Metrics.baseMargin) + Metrics.baseMargin * 3,
  },
})
